var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-btn",class:_vm.setupBtnClass},[(_vm.icon)?_c('i',{class:_vm.setupIconClass}):_vm._e(),_c('p',{class:_vm.setupTextClass},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }